module.exports = __webpack_public_path__ + "img/Main.94af803.png";